import React from "react"

const UsersContext = React.createContext({})

const { Provider, Consumer } = UsersContext

export { Provider, Consumer, UsersContext }
